import { FormArray, FormGroup } from '@angular/forms';
import { IAmenityForm } from '@curbnturf/form-helpers';

export function ParkingValidator(amenities: FormArray<FormGroup<IAmenityForm>>) {
  if (
    amenities.controls.find(
      (amenity: FormGroup<IAmenityForm>) => amenity.value.type === 'pullThrough' || amenity.value.type === 'backIn',
    )
  ) {
    return null;
  }
  return { invalidParking: true };
}
